import AffiliateLogo from './affiliate-logo';

export default AffiliateLogo;